// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip{position:relative;display:inline-block;margin-left:5px;margin-bottom:2px;padding:0 5px;background:#2b5449;color:#fff;font-weight:600;border-radius:100px}.tooltip:hover{cursor:pointer}.tooltip .tooltiptext{visibility:hidden;width:275px;background-color:#2b5449;color:#fff;text-align:center;border-radius:10px;padding:10px;transform:translateX(-50%) translateY(-115%);position:absolute;z-index:1}.tooltip:hover .tooltiptext{visibility:visible}", ""]);
// Exports
module.exports = exports;
